var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17.1254H6.75V18.3754H0.5V17.1254ZM24.6952 6.08623L24.2533 6.5282L24.25 6.52492L13.9445 16.8304L7.76601 18.375L9.31065 12.1965L20.0548 1.4458C21.3341 0.166504 23.4159 0.166504 24.6952 1.4458C25.9745 2.72525 25.9745 4.80686 24.6952 6.08623ZM13.625 15.3822L22.1171 6.89004L19.2576 4.01734L10.7589 12.516L13.625 15.3822ZM9.48399 16.6571L12.4025 15.9275L10.2136 13.7386L9.48399 16.6571ZM23.8113 2.32967C23.0522 1.57047 21.8365 1.53903 21.0395 2.23544L20.1415 3.13346L23.001 6.00618L23.9056 5.10158C24.6019 4.30461 24.5705 3.08894 23.8113 2.32967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a525ce0175d12ae838515548674519b4.svg";
export { ForwardRef as ReactComponent };